import { render, staticRenderFns } from "./updateTime.vue?vue&type=template&id=6547c8d6&"
import script from "./updateTime.vue?vue&type=script&lang=js&"
export * from "./updateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/system/updateTime.vue"
export default component.exports